import * as signalR from '@microsoft/signalr';
import { setupIbplanningEventListeners } from './utils/ibplanning';
import { setupDefaultEventListeners } from './utils/default';
import { setupDispatchEventListeners } from './utils/dispatch';
import Events from '../utilities/EventEmitter';
import { RMAXLogger } from '../services/LoggerService/RMAXLogger';
import { getAccessToken } from "../auth/TokenService";

class SignalRClient {
  constructor() {
    this.connection = null;
    this.terminalConnection = null;
    this.manualDisconnect = false;
  }

  startConnection = () => {
    this.connection
      .start()
      .then(() => {
        console.log(`Connection Started at ${new Date()}`);
        RMAXLogger.info(`Connection Started at ${new Date()}`);
        this.addUsersToGroups();
      })
      .catch((err) => {
        console.log('Error connecting to Notifications service ', err);
        RMAXLogger.error('Error connecting to Notifications service ', err);
        setTimeout(() => this.startConnection(), 5000);
      });
  };

  addUsersToGroups = () => {
    this.connection
      .invoke('addUserToGroup', this.tenantId, this.scenarioId)
      .catch((err) => console.error('Error while adding users to group ', err.toString()));
    this.connection
      .invoke('adduserToTerminalGroup', this.tenantId, this.terminalCode)
      .catch((err) => console.error('Error while adding users to terminal group ', err.toString()));
    console.log('Client Connected');
  };

  connectToHub = (scenario, terminal) => {
    let domainMatch = window.location.hostname.match(/^([a-z0-9]+)\.?/i);
    this.tenantId = domainMatch && domainMatch.length >= 2 ? domainMatch[1] : '';
    this.scenarioId = scenario;
    this.terminalCode = terminal;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl('/notifications', { accessTokenFactory: () => getAccessToken() /*, headers: { tenantId: 'saia' }*/})
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect([0, 6000, 15000, 30000, 60000])
      .build();
    this.startConnection();

    this.connection.serverTimeoutInMilliseconds = 480000;
    //Initialize Default event listeners
    setupDefaultEventListeners(this.connection);

    //Initialize Ibplanning event listeners
    setupIbplanningEventListeners(this.connection);
    //Initialize Dispatch event listeners
    setupDispatchEventListeners(this.connection);

    this.connection.onreconnecting((error) => {
      console.assert(
        this.connection.state === signalR.HubConnectionState.Reconnecting,
        'Error while reconnecting'
      );
      this.disconnectedTimestamp = new Date();
      console.log('Connection Disconnected: onReconnecting invoked', {
        error,
        disconnectTimeStamp: this.disconnectedTimestamp
      });
      RMAXLogger.warn('Connection Disconnected: onReconnecting invoked', {
        error: error?.message,
        disconnectTimeStamp: this.disconnectedTimestamp
      });
    });

    this.connection.onreconnected((connectionId) => {
      console.log('onreconnected called with connectionId', connectionId);
      console.assert(
        this.connection.state === signalR.HubConnectionState.Connected,
        'Error while reconnecting'
      );
      if (this.connection.state === signalR.HubConnectionState.Connected) {
        const reconnectedTimestamp = new Date();
        if (this.disconnectedTimestamp) {
          const duration = reconnectedTimestamp - this.disconnectedTimestamp;
          RMAXLogger.info(`Reconnected after ${duration} ms`);
          console.log(`Reconnected after ${duration} ms`);
        }
        this.addUsersToGroups();
      }
    });

    this.connection.onclose((error) => {
      console.log('Connection Closed', { error, isMaunalDisconnect: this.manualDisconnect });
      RMAXLogger.error(`Connection Closed Completely`, {
        error: error?.message,
        isMaunalDisconnect: this.manualDisconnect
      });
      !this.manualDisconnect && Events.emit('signalRConnectionFailure');
      this.manualDisconnect = false;
    });
  };

  disconnectFromHub = () => {
    if (this.connection) {
      this.manualDisconnect = true; //this flag should be set only when there is already an existing connection established.
      return this.connection.stop();
    } else return Promise.resolve();
  };
}
export default new SignalRClient();
